export const Products = {
  GENERAL: "0",
  TESTDAF: "1",
  TESTAS: "2",
  ONSET: "3",
  DUO: "4",
  DIGITAL_TESTAS: "5",
  INL: "6",
  DMAT: "7",
  DTZ: "8",
  GJUDAF: "9",
} as const;
